import { type UseFormRegister, type FieldErrors } from "react-hook-form";
import { FormInput } from "../../../../components/ui/Form/FormInput";
import { FormInputMask } from "../../../../components/ui/Form/FormInputMask";
import type { RecipientFormData } from "../../types/recipientModal.types";
import { isMobile } from "react-device-detect";

interface RecipientFormFieldsProps {
  register: UseFormRegister<RecipientFormData>;
  errors: FieldErrors<RecipientFormData>;
  isPhoneDisabled?: boolean;
  defaultPhone?: string;
  defaultFirstName?: string;
  defaultLastName?: string;
}

export const RecipientFormFields = ({
  register,
  errors,
  isPhoneDisabled = false,
  defaultFirstName = "",
  defaultLastName = "",
}: RecipientFormFieldsProps) => {
  return (
    <div className={`flex flex-col ${isMobile ? 'gap-4' : 'gap-[20px]'}`}>
      <div className={`flex ${isMobile ? 'flex-col gap-4' : 'flex-row gap-[20px]'}`}>
          <FormInput
            label="Имя"
            classNameForm={isMobile ? 'w-full' : 'w-[400px]'}
            className={`${isMobile ? 'h-[50px]' : 'h-[49px]'} !p-[15px]`}
            placeholder="Введите имя"
            {...register("firstName", { required: "Имя обязательно" })}
            error={errors.firstName?.message}
            defaultValue={defaultFirstName}
          />
          <FormInput
            label="Фамилия"
            classNameForm={isMobile ? 'w-full' : 'w-[400px]'}
            className={`${isMobile ? 'h-[50px]' : 'h-[49px]'} !p-[15px]`}
            placeholder="Введите фамилию"
            {...register("lastName")}
            error={errors.lastName?.message}
            defaultValue={defaultLastName}
          />
      </div>
    </div>
  );
};